/*
 eslint-disable global-require, no-unused-vars, react/prop-types
 */
// In order for the translations to work we need to initialize the worldready as the first thing when the application is loaded.
// initiate WorldReady
import '../../jsV2/helpers/initializeWorldReady';
import React from 'react';
import { render } from 'react-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { autoRehydrate, persistStore } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';
import axios from 'axios';
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react';
import worldReadyData from '../../jsV2/helpers/worldReadyData';
import rootReducer from './reducers/index';
import fetchActiveCommunityUserCount from './actions/action-community-online';
import getLocale from './actions/action-locale';
import { getHelpCenterAlerts } from './actions/index';

import fetchContactUsOnLogin from './actions/action-contact-us';
import { locationChecker } from './actions/action-contact-location';
import getPopularQuestions from '../home/actions/action-popular-list';
import Page from '../lib/page';
import {
  getCustomerJourneySessionKey,
  isNaaAlertEnabledInRC,
  setCustomerJourneySessionKey,
  validateAMFlag,
} from '../lib/globalHelper';
import { fetchPhoneNumber } from './actions/action-call-us';
import { getElmoExperiments } from '../home/actions/action-app';
import { elmoExperimentResourceNames } from '../lib/experiments-helper';
import { trackPage } from '../lib/analytics-helper';
import { isCustomerJourneyAPIEnabled } from '../lib/omnichannelHelper';
import { isNewContactUsExpEnabled } from '../../jsV2/helpers/twHelper';
import LayoutRenderer from './containers/LayoutRenderer';

const middlewares = [thunkMiddleware];

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require,  import/no-extraneous-dependencies */
  const defaultLogger = require('redux-logger');

  middlewares.push(defaultLogger.createLogger());
  /* eslint-enable global-require,  import/no-extraneous-dependencies */
}
const store = createStore(rootReducer, undefined, compose(autoRehydrate(), applyMiddleware(...middlewares)));

persistStore(
  store,
  {
    storage: asyncSessionStorage,
    whitelist: [
      'modal',
      'persistEmailForm',
      'user',
      'breadCrumb',
      'smcResultKeeper',
      'persistLocation',
      'persistedStepUp',
      'ocpContextResponse',
      'searchResult',
    ],
  },
  () => {
    store.dispatch(getLocale());
    // Check Page path for loading data
    store.dispatch(locationChecker());
    store.dispatch(fetchContactUsOnLogin());
  },
);

async function fetchElmoExpDetails() {
  await store.dispatch(getElmoExperiments(elmoExperimentResourceNames.contactUsVerbiageResourceName));
}

if (!isNewContactUsExpEnabled()) {
  // don't need to fetch active user at email pages
  if (!Page.getLogoutEmailRefId()) {
    store.dispatch(fetchActiveCommunityUserCount());
  }
  store.dispatch(getHelpCenterAlerts(false, 'contactUs'));

  // For logged in customers get BNA articles to check if any NAA restriction exists
  if (Page.isLoggedIn() && isNaaAlertEnabledInRC()) {
    store.dispatch(getPopularQuestions(Page.getUserExperience(), 'contactUs'));
  }

  // For logged in users fetch the elmo details for contact us verbiage resource name
  if (Page.isLoggedIn()) {
    fetchElmoExpDetails();
    // if remote config is enabled and customer journey session variable is not available make the customer journey API call
    if (!getCustomerJourneySessionKey() && isCustomerJourneyAPIEnabled()) {
      setCustomerJourneySessionKey(true); // setting in the session as customer journey is called
      const fptiPageId = Page.getFPTIPageId();
      trackPage({ id: `customerJourney${fptiPageId}`, link: 'smarthelp-customer-journey-api-called' });
      axios
        .post('/smarthelp/customer-journey', {
          _csrf: Page.getCSRFtoken(),
        })
        .then(() => {
          trackPage({ id: `customerJourneySuccess${fptiPageId}`, link: 'smarthelp-customer-journey-api-success' });
        })
        .catch(() => {
          trackPage({ id: `customerJourneyFailure${fptiPageId}`, link: 'smarthelp-customer-journey-api-failure' });
        });
    }
  }
}

Page.setCanonicalTag();

// Dispatching callus API on page load to enable callus option
// if customer has am flag
if (validateAMFlag()) {
  store.dispatch(fetchPhoneNumber());
}

const contactUsApp = () =>
  render(
    <Provider store={store}>
      <WorldReadyContextProvider locale={worldReadyData.locality.locale}>
        <LayoutRenderer />
      </WorldReadyContextProvider>
    </Provider>,
    document.querySelector('.smarthelp-react-app'),
  );

contactUsApp();
